// extracted by mini-css-extract-plugin
export default {"shell":"PageLayout_shell__ZeUD9","main":"PageLayout_main__tXpQQ"};